/**
 * Parses a date string and formats it as a "M/D/YYYY" string.
 *
 * @param dateString - A date string to parse.
 * @returns The date formatted as "M/D/YYYY".
 */
export const parseUtcDateString = (dateString: string) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1; // Months are zero-based, so we add 1
    const day = date.getDate();
    const year = date.getFullYear();
    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
};

/* Usage: Date inputs should be UTC date strings */
/**
 * Determines whether the current date falls within a given start/end date range.
 *
 * @param startDate - UTC start date string of the range.
 * @returns True if today's date falls within [startDate, endDate] inclusive.
 */
export const determineIfDateRangeIsCurrent = (startDate: string, endDate: string) => {
    const startDateUTC = new Date(startDate);
    const endDateUTC = new Date(endDate);
    const today = new Date();
    const todayUTC = new Date(today.toUTCString());
    if (todayUTC >= startDateUTC && todayUTC <= endDateUTC) {
        return true;
    } else {
        return false;
    }
}
